/**
 * Small display summaries for the result card (UnifiedBetCardView).
 * Pure functions so the card's wording is covered by unit tests.
 */

// "Cincinnati Bengals + Cam Grandy Over 0.5" for the SGP price row, which
// otherwise has no single line to show. Long parlays name the first legs only.
export function sgpLegSummary(legs, maxLegs = 2) {
    const names = (Array.isArray(legs) ? legs : [])
        .map(l => String(l?.selection || l?.name || '').trim())
        .filter(Boolean);
    if (names.length === 0) return null;
    if (names.length <= maxLegs) return names.join(' + ');
    return `${names.slice(0, maxLegs).join(' + ')} + ${names.length - maxLegs} more`;
}

// When every listed book posts the same price the rail rows all read alike;
// the card says so once at the top. Returns { price, count } over the books
// that have a price, or null.
export function sharedPrice(prices) {
    const nums = (Array.isArray(prices) ? prices : [])
        .filter(p => p !== null && p !== undefined && p !== '')
        .map(Number)
        .filter(Number.isFinite);
    if (nums.length < 2) return null;
    return nums.every(p => p === nums[0]) ? { price: nums[0], count: nums.length } : null;
}

// True when the devig methods give the same EV (in percent points) within tol.
export function methodsAgree(evs, tol = 0.05) {
    const nums = (Array.isArray(evs) ? evs : []).filter(Number.isFinite);
    if (nums.length < 2) return false;
    return Math.max(...nums) - Math.min(...nums) <= tol;
}
